function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".tracera_logo_svg__cls-2{fill:#005353}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "tracera_logo_svg__cls-2",
  d: "M92.8.05V5.9H78.08v42.76h-5.85V5.91H57.44V.05H92.8zM118.07 29.1l14.56 19.57h-7.32L106.9 23.79h7.7c5.16 0 9.25-3.85 9.25-9.01 0-4.78-3.93-8.71-8.63-8.71h-13.17v42.6h-5.93V.13h19.11c8.09 0 14.56 6.63 14.56 14.64 0 6.55-4.7 12.94-11.71 14.33h-.01zM158.82.13l21.19 48.54h-6.39l-7.24-16.41h-14.71l2.62-5.93h9.55l-7.01-16.02-16.79 38.37h-6.39L154.74.13h4.08zM186.33 24.4c0 10.02 8.24 18.41 18.26 18.41 6.32 0 12.25-3.31 15.64-8.55h6.86l-1.46 2.47c-4.47 7.47-12.25 11.94-20.96 11.94-13.41 0-24.27-10.86-24.27-24.19S191.34.13 204.74.13c8.63 0 16.41 4.47 20.88 11.94l1.46 2.47h-6.86c-3.39-5.24-9.32-8.55-15.64-8.55-9.94 0-18.26 8.4-18.26 18.41zM262.06.13v5.85h-24.5v15.49h19.49l-3.16 5.86h-16.33v15.48h24.5v5.86h-30.43V.13h30.43zM288.79 29.1l14.56 19.57h-7.32l-18.41-24.88h7.7c5.16 0 9.25-3.85 9.25-9.01 0-4.78-3.93-8.71-8.63-8.71h-13.17v42.6h-5.93V.13h19.11c8.09 0 14.56 6.63 14.56 14.64 0 6.55-4.7 12.94-11.71 14.33h-.01zM329.54.13l21.19 48.54h-6.39l-7.24-16.41h-14.71l2.62-5.93h9.55l-7.01-16.02-16.79 38.37h-6.39L325.46.13h4.08z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "tracera_logo_svg__cls-2",
  d: "M215.7 57.87v1.83h-4.59v13.33h-1.83V59.7h-4.61v-1.83h11.03zM231.09 65.46c0 4.16-3.43 7.57-7.61 7.57s-7.54-3.39-7.54-7.54 3.41-7.59 7.57-7.59 7.59 3.41 7.59 7.57h-.01zm-1.82 0c0-3.17-2.59-5.76-5.74-5.76s-5.76 2.62-5.76 5.76 2.57 5.76 5.74 5.76 5.76-2.59 5.76-5.76z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "tracera_logo_svg__cls-2",
  d: "M288.08 57.89v15.13h-1.85V61.3l-5.33 6.58h-.89l-5.38-6.58v11.72h-1.85V57.89h1.32l6.34 7.66 6.27-7.66h1.37zM296.89 57.89l6.6 15.13h-1.99l-2.26-5.12h-4.59l.82-1.85h2.98l-2.19-5-5.24 11.96h-1.99l6.58-15.13h1.28zM311.06 66.92l4.54 6.1h-2.28l-5.74-7.76h2.4c1.61 0 2.88-1.2 2.88-2.81 0-1.49-1.23-2.71-2.69-2.71h-4.11v13.28h-1.85V57.89h5.96c2.52 0 4.54 2.07 4.54 4.56 0 2.04-1.46 4.04-3.65 4.47zM316.72 57.89h1.85v15.13h-1.85V57.89zm10.69 0l-6.44 7.47 7.13 7.66h-2.43l-7.11-7.57 6.51-7.57h2.34zM338.67 57.89v1.83h-7.64v4.83h6.08l-.98 1.83h-5.09v4.83h7.64v1.83h-9.49V57.91h9.49v-.02zM350.67 57.87v1.83h-4.59v13.33h-1.83V59.7h-4.61v-1.83h11.03z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "tracera_logo_svg__cls-2",
  d: "M240.33 73.02h-.96V58.79h-3.91v-.9h8.79v.9h-3.91v14.23zM256.14 64.32V57.9h.96v15.13h-.96v-7.81h-9.19v7.81h-.96V57.9h.96v6.42h9.19zM261.31 58.8v5.5h6.1v.9h-6.1v6.92h6.26v.9h-7.22V57.89h7.22v.9h-6.26z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "tracera_logo_svg__cls-2",
  d: "M180.53 56.47h.9v8.89h.04c.78-1.16 2.15-1.81 3.57-1.81 2.77 0 4.54 2.07 4.54 4.78s-1.77 4.9-4.58 4.9c-1.36 0-2.85-.68-3.53-1.87h-.04v1.67h-.9V56.48zm8.15 11.86c0-2.03-1.46-3.93-3.61-3.93-2.35 0-3.69 1.75-3.69 3.95s1.36 4.03 3.65 4.03 3.65-1.93 3.65-4.05zM190.08 63.75h.94l3.95 8.39 3.55-8.39h.92l-6.22 14.69h-.92l2.23-5.26-4.46-9.43h.01z"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "tracera_logo_svg__xo8sjq"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48.54 48.66H6.83c0-23.05 18.66-41.83 41.71-41.83v41.83z",
  fill: "#005354"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "tracera_logo_svg__path122",
  d: "M0 45.49C3.66 21.34 23.17 2.56 47.57 0H0v45.49z",
  fill: "#0eb5a6",
  fillRule: "evenodd"
});

function SvgTraceraLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tracera_logo_svg__Layer_1",
    "data-name": "Layer 1",
    width: 350.73,
    height: 78.44
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default __webpack_public_path__ + "b9b4e4fbb9fb56bb318e05f89195ad72.svg";
export { SvgTraceraLogo as ReactComponent };